export default "__VITE_ASSET__eIwJ_v1j__"